import { render, staticRenderFns } from "./vipAction.vue?vue&type=template&id=0b3396de&scoped=true&"
import script from "./vipAction.vue?vue&type=script&lang=js&"
export * from "./vipAction.vue?vue&type=script&lang=js&"
import style0 from "./vipAction.vue?vue&type=style&index=0&id=0b3396de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3396de",
  null
  
)

export default component.exports